import { Link } from "react-router-dom";

export default function SideMenu() {
    function clearToken(e) {
        e.preventDefault();
        const ask = prompt('You will not be able to login! \nAre you sure you want to clear the token? Type "yes" to confirm.');

        if (ask && ask.toLowerCase() === "yes") {
            window.localStorage.removeItem("token");
            window.location.reload();
        }
        else {
            alert("Token not cleared.");
        }

    }
    return (
        <div className="side-menu hidden">
            <div className="profile-section">
                <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" alt="User Icon" className="user-icon" />
                <p>Admin</p>
            </div>
            <hr />
            <ul>
                <li><Link to="/dashboard">Dashboard</Link></li>
                <li><Link to="/products">Products</Link></li>
                <li><Link to="/dashboard">Transactions</Link></li>
                <li><Link to="/dashboard">Settings</Link></li>
                <li><Link to="/dashboard">Help</Link></li>

                <li><button onClick={clearToken}>Logout</button></li>
            </ul>
        </div>
    );
}